var isBufferExports = {};
var isBuffer = {
  get exports() {
    return isBufferExports;
  },
  set exports(v) {
    isBufferExports = v;
  }
};
export { isBuffer as __module, isBufferExports as exports };
//# sourceMappingURL=isBuffer.js.map
